module.exports = __webpack_public_path__ + "static/media/ΠΡΟΤΥΠΟ ΑΦΙΣΑ_1.4f899704.mp4";